import React from 'react'
import { BeWizrMeetingOccurrence } from '~/models'
import { memo } from '~/ui/component'
import BeWizrMeetingTile from '../../bewizr-meetings/BeWizrMeetingTile'
import { register } from './registry'
import { useTranslation } from 'react-i18next'

export interface Props {
  item: BeWizrMeetingOccurrence
}

const BeWizrMeetingOccurrenceLibraryItem = memo('BeWizrMeetingOccurrenceLibraryItem', (props: Props) => {

  const {item} = props

  const [t] = useTranslation('bewizr-library')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrMeetingTile
        label={t('item-types.occurrence')}
        meetingID={item.meetingId}
        occurrenceID={item.id}
        title={item.title}
        image={item.links.image}
        capacity={item.capacity}
        isEnrolled={item.isEnrolled}
        isOnWaitingList={item.isOnWaitingList}
        placesLeft={item.placesLeft}
        startDate={item.startDate}
        endDate={item.endDate}
        mayEnroll={item.mayEnroll}
        description={item.shortDescription}
        horizontal
      />
    )
  }

  return render()

})

register('occurrence', BeWizrMeetingOccurrenceLibraryItem)